import script from "./StravaAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./StravaAuth.vue?vue&type=script&setup=true&lang=js"

import "./StravaAuth.vue?vue&type=style&index=0&id=d3f552f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3f552f2"]])

export default __exports__